import styled from 'styled-components';

import { darken } from 'polished';

import Colors from '../../theme/Colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px;
  /*max-height: 70%;*/
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: ${Colors.grayDark};

  p {
    margin: 0;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    color: ${Colors.green};
  }
`;

export const ItemsContainer = styled.div`
  height: 100%;
  /* height: 100%; */
  /* min-height: calc(100% - 350px); */
  max-height: calc(100vh - 350px);
  overflow: scroll;
  padding-bottom: 60px;

  &::-webkit-scrollbar {
    width: 0;
  }

  @media (max-height: 600px) {
    max-height: calc(100vh - 400px);
  }
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  footer {
    display: flex;
    align-items: flex-start;

    input {
      width: 30px;
      height: 25px;
      text-align: center;
      vertical-align: middle;
      font-size: 12px;
      border: none;
      outline: none;
      font-weight: bold;
    }

    button {
      width: 25px;
      height: 25px;
      border-radius: 4px;
      background-color: ${Colors.secondary};
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      outline: none;
    }
  }
`;

export const ItemData = styled.div`
  display: flex;
  cursor: pointer;

  > figure {
    margin: 0;
    display: flex;
    flex-direction: column;
  }

  img {
    width: 30px;
    height: 30px;
    margin-right: 8px;
    object-fit: cover;
    border-radius: 4px;
  }
  div > p,
  div > span {
    font-size: 12px;
    margin: 0;
    line-height: 1;
  }

  section {
    font-size: 12px;
  }

  section > p {
    margin: 0;
    margin-bottom: 4px;
  }
`;

export const ResumeContainer = styled.div`
  position: absolute;
  bottom: 0;
  background: #fff;
  padding: 12px 8px;

  > div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  > div > h3 {
    font-size: 16px;
    color: ${Colors.green};
    margin: 0;
    font-weight: bold;
  }

  > button {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    background-color: ${Colors.secondary};
    color: #fff;
    font-weight: bold;
    border-bottom: 4px solid ${darken(0.3, Colors.secondary)};
    outline: none;
  }

  > button:disabled {
    opacity: 0.5;
  }

  input {
    color: #383838;
    border: 0;
    font-size: 14px;
    /* padding: 8px; */
    /* border: 1px solid #b4b4b4; */
    /* border-radius: 8px; */
  }

  input:focus {
    outline: none;
  }
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #eeeeee;
  font-weight: bold;

  i {
    font-size: 120px;
  }
`;
